import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './modules/auth/components/login/login.component';
import {ClassroomClosedComponent} from '@app/modules/shared/components/classroom-closed/classroom-closed.component';
import {IncorrectUrlComponent} from '@app/modules/shared/components/incorrect-url/incorrect-url.component';
import {LoginDetailsComponent} from '@app/modules/auth/components/login-details/login-details.component';
import {GuestComponent} from '@app/modules/auth/components/guest/guest.component';
import {
  DiagnosticsLoginPageComponent
} from '@app/modules/diagnostics/components/diagnostic-enter-page/diagnostics-login-page.component';
import {MainPageComponent} from '@app/components/main-page/main-page.component';
import {
  DiagnosticsReportComponent
} from '@app/modules/diagnostics/components/diagnostics-report/diagnostics-report.component';
import {DiagnosticsComponent} from '@app/modules/diagnostics/components/diagnostics/diagnostics.component';
import {SessionEndedComponent} from '@app/modules/shared/components/session-ended/session-ended.component';

const routes: Routes = [

  // CLASSROOM-SPECIFIC - !!! NESTING WILL NOT WORK (root base-href is disabled)
  {path: 'incorrect-url', component: IncorrectUrlComponent},

  {path: 'diagnostics', component: DiagnosticsComponent},
  {path: 'diagnostics/report', component: DiagnosticsReportComponent},
  {path: 'diagnostics/enterPage', component: DiagnosticsLoginPageComponent},
  {path: 'diagnostics/login', component: LoginComponent},

  {path: ':roomNum/diagnostics', component: DiagnosticsComponent},
  {path: ':roomNum/diagnostics/report', component: DiagnosticsReportComponent},
  {path: ':roomNum/diagnostics/enterPage', component: DiagnosticsLoginPageComponent},
  {path: ':roomNum/diagnostics/login', component: LoginComponent},
  {path: ':roomNum/guest', component: GuestComponent},
  {path: ':roomNum/classroomClosed', component: ClassroomClosedComponent},
  {path: ':roomNum/sessionEnded', component: SessionEndedComponent},
  {path: ':roomNum/login', component: LoginComponent},
  {path: ':roomNum/loginDetails', component: LoginDetailsComponent},
  {path: ':roomNum/', component: MainPageComponent},
  {path: ':roomNum', redirectTo: ':roomNum/'},

  // PAGE ISN'T FOUND
  {path: '**', redirectTo: '/incorrect-url'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
